import React from "react"
import type Sign from "@/signomatic/app/sign"

export const SignContext = React.createContext<Sign | undefined>(undefined)
export const ActiveButtonContext = React.createContext<React.RefObject<HTMLDivElement> | undefined>(undefined)

export const useSign = () => React.useContext(SignContext)
